import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import { colors } from '../config/theme';

const useStyles = createUseStyles({
  text: props => ({
    fontFamily: props.family,
    fontSize: props.size,
    color: props.color,
    fontWeight: props.weight,
    ...props
  })
});

const Text = ({ className, children, ...props }) => {
  const classes = useStyles(props);
  return (
    <p className={`${classes.text} ${className}`} {...props}>
      {children}
    </p>
  );
};

/**
 * Prop-types of the Component
 */
Text.propTypes = {
  family: PropTypes.oneOf(['GTAM', 'GTAMI', 'GTAR', 'GTARI']),
  weight: PropTypes.number,
  size: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.any
};

/**
 * Some default props to the Component
 */
Text.defaultProps = {
  family: 'GTAR',
  size: '14px',
  weight: 500,
  color: colors.mineShaft
};

export default Text;
